import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';

const CONTENT_DISPOSITION_FILENAME_REGEX = /filename\s*=\s*(?:"([^"]+)"|([^;]+))/i;
const QUOTED_FILENAME_GROUP = 1;
const UNQUOTED_FILENAME_GROUP = 2;

const saveBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getFilenameFromContentDisposition = (
  contentDisposition?: string,
): string | undefined => {
  const match = contentDisposition?.match(CONTENT_DISPOSITION_FILENAME_REGEX);
  if (!match) {
    return undefined;
  }
  return (match[QUOTED_FILENAME_GROUP] || match[UNQUOTED_FILENAME_GROUP])?.trim();
};

export const downloadFileFromBlob = (data: string, filename: string): void => {
  saveBlob(new Blob([data]), filename);
};

/**
 * Downloads a file served by a POST endpoint of the new API. The filename and the
 * content type are taken from the response, because the backend decides on its own
 * whether the payload is zipped (see the ZIP rule of the map download endpoints).
 */
export const downloadFileFromNewApiPost = async (
  path: string,
  body: unknown,
  fallbackFilename: string,
): Promise<void> => {
  const response = await axiosInstanceNewAPI.post(path, body, {
    responseType: 'arraybuffer',
  });

  const contentType = response.headers['content-type'] || 'application/octet-stream';
  const filename =
    getFilenameFromContentDisposition(response.headers['content-disposition']) || fallbackFilename;

  saveBlob(new Blob([response.data], { type: contentType }), filename);
};
